import { useCallback } from "react";

/**
 * Generates initials from a name or email.
 * - If fullName has multiple words: first + last initial (e.g., "Juan Pérez" → "JP")
 * - If fullName has one word: first letter (e.g., "Admin" → "A")
 * - If no name provided but email exists: first two chars of email local part (e.g., "jp@example.com" → "JP")
 */
export function useInitials() {
  return useCallback((fullName: string, email?: string): string => {
    const trimmed = fullName?.trim();

    if (trimmed && trimmed.length > 0) {
      const names = trimmed.split(/\s+/);

      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
      }

      const firstInitial = names[0].charAt(0);
      const lastInitial = names[names.length - 1].charAt(0);
      return `${firstInitial}${lastInitial}`.toUpperCase();
    }

    // Fallback: use email local part
    if (email) {
      const localPart = email.split("@")[0];
      if (localPart.length >= 2) {
        return localPart.slice(0, 2).toUpperCase();
      }
      return localPart.charAt(0).toUpperCase();
    }

    return "??";
  }, []);
}
